// Tailwind's `lg` (1024px). Below it the sidebar is a drawer and the online-users rail is not
// drawn; a button in the top bar opens the same list as a sheet over the page.
export const BELOW_DESKTOP_QUERY = "(max-width: 1023.98px)";

export function isBelowDesktop(): boolean {
  return typeof window.matchMedia === "function" && window.matchMedia(BELOW_DESKTOP_QUERY).matches;
}
